<template lang="pug">
div
  .map.uk-position-relative
    //-==========================
      Map 
    //-==========================
    #hazardmap.map__container

    //-==========================
      Components
    //-==========================
    //- Header
    vue-hazardmap-header-component
    //- Messages
    vue-hazardmap-message-component
    //- Guides
    vue-hazardmap-guide-component
    //- Memo for Print
    vue-hazardmap-memo-for-printer-component
    //- Kikikuru and Snowd Layer
    vue-hazardmap-kikikuru-component
    //- Offcanvas
    vue-hazardmap-offcanvas-component
    //- Attribution
    vue-hazardmap-attribution-component

</template>

<script>
import * as types from "../js/mutations/map-mutations"
//- Components
import VueHazardmapHeaderComponent from "./VueHazardmapHeaderComponent.vue"
import VueHazardmapGuideComponent from "./VueHazardmapGuideComponent.vue"
import VueHazardmapMessageComponent from "./VueHazardmapMessageComponent.vue"
import VueHazardmapKikikuruComponent from './VueHazardmapKikikuruComponent.vue'
import VueHazardmapOffcanvasComponent from './VueHazardmapOffcanvasComponent.vue'
import VueHazardmapMemoForPrinterComponent from "./VueHazardmapMemoForPrinterComponent.vue"
import VueHazardmapAttributionComponent from "./VueHazardmapAttributionComponent.vue"


export default {
  /*
    Components 
  /*---------------------------------------*/
  components: {
    VueHazardmapGuideComponent, VueHazardmapMessageComponent,
    VueHazardmapMemoForPrinterComponent, VueHazardmapHeaderComponent,
    VueHazardmapKikikuruComponent, VueHazardmapOffcanvasComponent,
    VueHazardmapAttributionComponent,
  },

  /*
    Mounted 
  /*---------------------------------------*/
  async mounted() {
    await this.$store.dispatch(types.INIT_MAP);
  },

  /*
    Computed 
  /*---------------------------------------*/
  computed: {
    logo_url() { return this.$store.getters.logo_url },
  },

};
</script>
